import React, { useState } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
// import attachments from "assets/img/icons/Attach ment-01.svg"

const Share = ({ show, handleClose }) => {
    const [emailAddress, setEmailAddress] = useState('');
    const [email, setEmail] = useState('');
    const [validated, setValidated] = useState(false);



    const handleSendEmail = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
        }
        else {
            const data = {
                mailTo: emailAddress,
                emailMessage: email
            }
            handleClose();
        }
    };

    return (
        <Modal show={show} onHide={handleClose} size='md' centered={true}>
            <Modal.Body>
                <p className='adnote-font'>Forward message</p>
                <Form noValidate validated={validated} onSubmit={handleSendEmail}>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Control
                            type="email"
                            placeholder="Add emails or people"
                            autoFocus
                            onChange={(e) => setEmailAddress(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Control as="textarea" rows={7} onChange={(e) => setEmail(e.target.value)} className='p-2' required />
                    </Form.Group>
                    <Row className='d-flex justify-content-end align-items-center'>
                        <Col md={4} className='p-0 ml-5'>
                            <Form.Check
                                type="checkbox"
                                id="custom-checkbox"
                                label="Add notes"
                                onChange={(e) => console.log('Checkbox checked:', e.target.checked)}
                            />
                        </Col>
                        <Col md={6}>
                            <Button variant="secondary" onClick={handleClose} className='custom-modal-button shadow'>
                                Cancel
                            </Button>
                            <Button variant="secondary" type='submit' className='custom-modal-button shadow'>
                                Send
                            </Button>
                        </Col>

                    </Row>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default Share;
